export enum DocketStatus {
  CREATED = 'CREATED',
  COMPLETED = 'COMPLETED',
}

export enum DOCKET_ACTION {
  DOCKET_CREATE = 'DOCKET_CREATE',
  DOCKET_CREATE_ITEM = 'DOCKET_CREATE_ITEM',
}

export enum DocketItemStatus {
  CREATED = 'CREATED',
  COMPLETED = 'COMPLETED',
  VOIDED = 'VOIDED',
  BUMPED = 'BUMPED',
  RECALLED = 'RECALLED',
  SERVED = 'SERVED',
  REBUMPED = 'REBUMPED',
  TRANSFERRED = 'TRANSFERRED',
}
